import { Image, Text } from '@mantine/core';

interface TitleTextProps {
  imageWidth?: number;
  hasSubtitle?: boolean;
}

export function TitleText({ imageWidth = 250, hasSubtitle = true }: Readonly<TitleTextProps>) {
  return (
    <>
      <Image
        src="/assets/gti/logo-secondary-light.svg"
        alt="GTI"
        mx="auto"
        mb="md"
        w={imageWidth}
      />
      {hasSubtitle && (
        <Text
          size="xl"
          c="var(--mantine-color-gray-6)"
          ta="center"
          mt="md"
          maw={imageWidth * 3}
          mx="auto"
        >
          Complete TPRM Due Diligence in One Platform
        </Text>
      )}
    </>
  );
}
